import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import Information from 'modules/Information';
import LegalConsentField from '../LegalConsentField';
const CommunicationConsents = ()=>{
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const legalConsent = consentsTemplate.find((consent)=>consent.type === 'Email');
    if (!legalConsent) {
        return null;
    }
    return /*#__PURE__*/ _jsx(LegalConsentField, {
        legalConsent: legalConsent
    });
};
export default CommunicationConsents;
